<div class="modal-body">
  <div id="modal-header-wrapper">
    <h2 id="title-text">Sélectionner un patient</h2>
  </div>
  <div id="modal-content-wrapper">
    <div id="header-wrapper">
      <msd-search-bar (searchEvent)="updateSearchQuery($event)"></msd-search-bar>
    </div>

    <div class="patients-list-wrapper">

      <div class="append-loader" *ngIf="isAppendLoading">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="ml10px">Chargement...</span>
      </div>
      <table class="table header">
        <thead>
        <tr>
          <th scope="col">Nom du patient</th>
          <th id="group" scope="col">Groupe</th>
          <th id="application" scope="col">Application</th>
        </tr>
        </thead>
      </table>
      <div (scrolled)="onScroll()" [scrollWindow]="false" id="patients-list-wrapper"
           infiniteScroll>
        <ng-container
          *ngIf="
        !isOnError && !isLoading && patientsList && patientsList.length > 0;
        else innerLoading
      "
        >
          <table class="table">
            <tbody>
            <tr
              msd-patient-cell
              *ngFor="let patient of patientsList"
              (onClick)="selectPatient(patient)"
              [appInstalled]="patient.isActive"
              [isActionLoading]="patientPerformingAction === patient.id.toString()"
              [avatarUrl]="patient.avatarUrl"
              [initials]="patient.initials"
              [title]="patient.fullName"
              [withActionButton]="false"
              [groups]="getGroupsLabel(patient.groupId)">
            </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-template #innerLoading>
          <ngx-inner-loading
            class="flex-center"
            [empty]="patientsList?.length === 0"
            [error]="isOnError"
            [loading]="isLoading"
            (retry)="loadPatients(currentPage)"
            [loadingDescription]="'Chargement...'"
            [emptyDescription]="'Aucun patient'"
            [errorDescription]="'Une erreur est survenue. Veuillez réessayer plus tard.'"
            [retryButtonText]="'Réessayer'">
          </ngx-inner-loading>
        </ng-template>
      </div>


    </div>
  </div>
</div>
<div class="modal-footer">
  <button id="cancel-button" (click)="onCancel.emit(); hideModal()" type="button"
          class="btn btn-outline-primary btn-outline text-only">
    Annuler
  </button>
</div>
